'use strict';

export default {
    notes: state => state.notes,

    notesForUser: state => userId => state.notes[userId]
};
